export default __webpack_public_path__ + "static/media/card.7358f9ab.svg";